"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Follow", {
  enumerable: true,
  get: function get() {
    return _Follow.default;
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _Share.default;
  }
});

var _Follow = _interopRequireDefault(require("./Follow"));

var _Share = _interopRequireDefault(require("./Share"));